// extracted by mini-css-extract-plugin
export default {"title":"ListOfAdvantages_title__G2wfd","wrapper":"ListOfAdvantages_wrapper__0daGY"};